export const uniforms = () => {
    return {};
};
export const defines = {
    // TRANSITION_MODE: 1, // 0: vertical, 1: radial - moved to uniform
};
export const shaderChunks = {
    uniforms: /* glsl */ `
    `,
    funcs: /* glsl */ `

        vec3 hsv2rgb_custom(vec3 c) {
            vec4 K = vec4(1.0, 2.0/3.0, 1.0/3.0, 3.0);
            vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
            return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
        }
        
        float getTransitionValue(vec3 pos, float progress) {
            
            if (TRANSITION_MODE == 0) {
                vec3 bb_corner = vec3(2., 1., 0);
                float normalizedY = (pos.y + bb_corner.x) / (bb_corner.y * 2.0);
                return (1.0 - normalizedY) - progress;
            } else {
                // Radial: normalize distance by the maximum possible distance in the bounds
                vec3 bb_corner = vec3(0.38145, 0.68065, 0);
                float maxDistance = length(bb_corner * 1.0) ;
                float normalizedDistance = length(pos) / maxDistance;
                return normalizedDistance - (progress+1.0);
            }
        }
    `,
};
